import React from 'react';
import { observer } from "mobx-react";

import {
  BaseModelCollection,
  AppState,
  Client,
  getClients,
  getAppState,
} from '../models';

import {
  BaseCollectionPage,
} from './BaseCollectionPage';
import { TextField, List, Subheader, ListItem, Button } from "react-md";
import { getApi } from "../api";
import HelpView from "../components/HelpView";


interface ClientsProps {
  history?: any;
  match?: any;
  location?: any;
}

type ComponentState = any;



@observer
class Clients extends BaseCollectionPage<ClientsProps, ComponentState> {
  viewName = 'Clients';
  objectName = 'client';
  store = 'my_models';

  get objectLabel() {
    return "Client";
  }

  

  
  

  
  get defaultViewMode() {
    return 'table';
  }
  get viewModeOptions(): string[] {
    return [
      'table',
    ];
  }
  

  getCollection(): BaseModelCollection {
    return getClients();
  }

  getAppState(): AppState {
    return getAppState();
  }

  get customFilters(): any[] {
    let filters: any = []
    
      filters = ["created_by","status","sales_person"]
    

    let customFilters: any[] = [];

    let obj = new Client();
    filters.forEach((key: string) => {
      let field = obj.getFieldInfo(key);
      if (!field) return;

      let filter: any = {
        key: key,
        label: field.label,
        type: field.type,
      };

      if ((field.type == 'model') || (field.type == 'models')) {
        filter['collectionName'] = field.objectName;
      }

      if (field.type == 'select') {
        filter['options'] = field.options;
      }

      customFilters.push(filter);
    })

    return customFilters;
  }

  

  

  

  
  


}

export default Clients;